import { gql } from '@apollo/client';

export const SEGMENT = gql`
  query Segment($segmentId: ID!) {
    segment(id: $segmentId) {
      surveys(surveyType: "screener") {
        id
        questions(questionOrder: "asc") {
          id
          label
          questionType
          questionOrder
          randomize
          screenerRatingPercentage
          treeTestNodes {
            id
          }
          followUpQuestions{
            id
            label
            questionType
            leftLabel
            rightLabel
            randomize
            questionOrder
            questionOptions(preserveOrder: true) {
              id
              label
              disqualify
              qualify
              optionType
            }
          }
          questionOptions(preserveOrder: true) {
            id
            label
            disqualify
            qualify
            optionType
            order
            optionRatingPercentage
          }
        }
      }
    }
  }
`;

export const UPDATE_SCREENER_QUESTIONS = gql`
  mutation UpdateSegmentScreenerQuestions($segmentId: ID!, $attributes: SurveyAttributes!) {
    updateSegmentScreenerQuestions(segmentId: $segmentId, attributes: $attributes) {
     survey {
      id
     }
    }
  }
`;
